exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3H6M4 {\n    white-space: nowrap;\n}\n\n._3H6M4:link,\n._3H6M4:hover,\n._3H6M4:visited,\n._3H6M4:active {\n    color: inherit;\n    text-decoration: underline !important;\n}\n\n._3H6M4:focus {\n    outline: rgb(193,228,254) solid 3px;\n}", ""]);

// Exports
exports.locals = {
	"link": "_3H6M4"
};